export enum MachineLearningProcessStatus {
  NotProcessed = 'NotProcessed',
  Processing = 'Processing',
  Processed = 'Processed',
  Failed = 'Failed',
}
